import { Link, useNavigate } from 'react-router-dom';
import { PROFILE_EDIT_LINK, PROFILE_MAIN_LINK } from '../../../../assets/utils/constants';
import './PasswordChange.css';
import ProfileGoBackButton from '../../ProfileGoBackButton/ProfileGoBackButton';

import { useState } from 'react';
import Input from '../../../Input/Input';
import MiniPreloader from '../../../MiniPreloader/MiniPreloader';
import mainAppApi from '../../../../assets/api/MainAppApi';
import useAutoDismissError from '../../../../assets/hooks/useAutoDismissError';
import { parseApiError } from '../../../../assets/utils/utils';

function PasswordChange() {

    const [values, setValues] = useState({
        current_password: '',
        new_password: '',
        check_new_password: '',
    })

    function handleChange(e) {
        const input = e.target;
        const name = input.name;
        let value = input.value;

        switch (name) {

            default:
                setValues((prevValue) => ({
                    ...prevValue,
                    [name]: value,
                }));
                break;
        }
    }

    const [preloaders, setPreloaders] = useState({
        checkPassword: false,
        updatePass: false,
    })

    const [step, setStep] = useState(0)
    const [checkPasswordError, setCheckPasswordError] = useAutoDismissError()

    function handleCheckPassword() {
        setPreloaders(prevValue => ({
            ...prevValue,
            checkPassword: true,
        }))
        mainAppApi.changePasswordCheckCurrent({
            current_password: values.current_password,
        })
            .then((res) => {
                console.log(res)
                setStep(1)

            })
            .catch((err) => {
                console.log(err)
                setCheckPasswordError('Oops! That password doesn’t seem right. Please try again.')
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    checkPassword: false,
                }))
            })
    }

    const [updatePassError, setUpdatePassError] = useAutoDismissError()
    function handleUpdatePass() {
        setPreloaders(prevValue => ({
            ...prevValue,
            updatePass: true,
        }))
        mainAppApi.changePasswordUpdate({
            current_password: values.current_password,
            new_password: values.new_password,
        })
            .then((res) => {
                console.log(res)
                setStep(2)
            })
            .catch((err) => {
                console.log(err)
                setUpdatePassError(parseApiError(err))
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    updatePass: false,
                }))
            })
    }
    const navigate = useNavigate()
    return (
        <div className='password-change'>
            <div className='password-change__heading'>
                <ProfileGoBackButton
                    onClick={() => {
                        navigate(`/${PROFILE_MAIN_LINK}/${PROFILE_EDIT_LINK}`)
                    }}
                />
                <div className='password-change__heading-title-box' >
                    <p className='password-change__heading-title'>Update Password</p>
                </div>
            </div>
            {step === 0 ?
                <>
                    <div className='password-change__inputs'>
                        <div className='password-change__input-item'>
                            <p className='password-change__input-title'>Current Password</p>
                            <div className='password-change__input-box'>
                                <Input
                                    value={values.current_password}
                                    handleChange={handleChange}
                                    name={"current_password"}
                                    placeholder={'Enter Your Current Password'}
                                    inputMode='text'
                                />
                            </div>
                        </div>
                    </div>
                    <button className={`password-change__submit ${!(values.current_password && values.current_password.length >= 8) || preloaders.checkPassword ? 'password-change__submit_inactive' : ''}`} type='button' onClick={handleCheckPassword}>
                        {preloaders.checkPassword ? <MiniPreloader isLinkColor={true} /> : 'Check password'}
                    </button>
                    {checkPasswordError ?
                        <p className='password-change__submit-error'>{checkPasswordError}</p>
                        : null}
                </>
                : null}

            {step === 1 ?
                <>
                    <div className='password-change__inputs'>
                        <div className='password-change__input-item'>
                            <p className='password-change__input-title'>Set a New Password</p>
                            <p className='password-change__input-subtitle'>Enter a&nbsp;new password (at&nbsp;least 8&nbsp;characters) and confirm&nbsp;it. <br />Make sure it&rsquo;s strong and something you&rsquo;ll remember.</p>
                            <div className='password-change__input-box'>
                                <Input
                                    value={values.new_password}
                                    handleChange={handleChange}
                                    name={"new_password"}
                                    placeholder={'Enter a New Password'}
                                    inputMode='text'
                                />
                            </div>
                        </div>

                        <div className='password-change__input-item'>
                            <div className='password-change__input-box'>
                                <Input
                                    value={values.check_new_password}
                                    handleChange={handleChange}
                                    name={"check_new_password"}
                                    placeholder={'Confirm New Password'}
                                    inputMode='text'
                                />
                            </div>
                        </div>
                    </div>
                    <button className={`password-change__submit ${!(values.new_password && values.new_password.length >= 8 && values.new_password === values.check_new_password && values.new_password !== values.current_password) || preloaders.updatePass ? 'password-change__submit_inactive' : ''}`} type='button' onClick={handleUpdatePass}>
                        {preloaders.updatePass ? <MiniPreloader isLinkColor={true} /> : 'Update password'}
                    </button>
                    {updatePassError ?
                        <p className='password-change__submit-error'>{updatePassError}</p>
                        : null}
                </>
                : null}

            {step === 2 ?
                <>
                    <div className='password-change__succsess'>
                        <p className='password-change__input-title'>Password Successfully Updated</p>
                        <p className='password-change__input-subtitle'>Your password has been changed. <br />You&rsquo;ll use the new password the next time you sign&nbsp;in.</p>

                    </div>
                    <Link to={`/${PROFILE_MAIN_LINK}`} className={`password-change__submit `} >
                        Return to profile
                    </Link>
                </>
                : null}



        </div>
    );
}

export default PasswordChange